export const recipesSlider = (instance, options) => {
    return {
        loop: false,
        slidesPerView: 'auto',
        slidesPerGroup: 1,
        spaceBetween: 15,
        cssMode: true,
        breakpoints: {
            1024: {
                cssMode: false,
                spaceBetween: 24,
                slidesPerView: 2,
                slidesPerGroup: 2
            }
        },
    }
}

export const alternativeRecipesSlider = (instance, options) => {
    let responsiveItemCounts = {
        1024: 3,
        1800: 4,
    }

    let breakpoints = {}

    for (const resolution in responsiveItemCounts) {
        const count = responsiveItemCounts[resolution]

        breakpoints[resolution] = {
            slidesPerView: count,
            slidesPerGroup: count,
            spaceBetween: 20,
            cssMode: false,
            pagination: {
                dynamicBullets: false,
            }
        }
    }

    return {
        loop: false,
        slidesPerView: 'auto',
        slidesPerGroup: 1,
        spaceBetween: 0,
        cssMode: true,
        breakpoints: breakpoints
    }
}